import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onFindMe: () => void
  options: { title: string; description: string; onClick: () => void }[]
}

const Header = ({ children, onFindMe, options }: React.PropsWithChildren<Props>) => {
  return (
    <Box
      height="s80"
      width="full"
      background="grey200"
      paddingX="s24"
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      gap="s8"
      border={{
        bottom: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
    >
      {children}
      <Button type="secondary" onClick={onFindMe} iconName="recruiting">
        {i18n.t('employees.orgchart.find_me_button')}
      </Button>
      {options.length > 0 && (
        <PopoverMenu type="list">
          <PopoverMenu.Trigger asChild>
            <Button type="secondary" iconName="ellipsis"></Button>
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="end">
            {options.map((option, index) => (
              <PopoverMenu.TouchableOption
                key={index}
                title={option.title}
                description={option.description}
                onClick={option.onClick}
              />
            ))}
          </PopoverMenu.Content>
        </PopoverMenu>
      )}
    </Box>
  )
}

export default Header
